import { Base } from "../core/base.model";
import { Proyecto } from "./proyecto";

export class EpicasBean extends Base{
      id: number;
	  descripcion: string; 
	  nombre: string;
	  prioridad: number;  
	  riesgo: number; 
	  esfuerzo: number; 
	  valor_negocio: number; 
	  fecha_inicio:Date ; 
	  fecha_planeada_termino: Date; 
	  fecha_registro: Date;
	  id_proyecto: string;
	  tiempo_critico: string;
	
	  proyecto: Proyecto;
}